module.exports = __webpack_public_path__ + "assets/img/free_1.d6441891.png";